import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setMobileMenuState } from './store/dataSlice';
import {
    Menu18x14Svg,
} from '../svg';

function MobileHeader(props) {
    const { locale } = props
    const dispatch = useDispatch();

    const openMobileMenu = () => {
        dispatch(setMobileMenuState(true));
    };

    let logo;

    if (locale === 'sq') {
        logo = (
            <div className="mobile-header__logo">
                {/* <Link to="/Home"><img src="../../../public/images/logot/logo.png" alt="" /></Link> */}
                <Link to="/"><img src="/img/logo/web/apk-logo.png" alt="mobile-logo-sq" /></Link>
            </div>
        );
    } else if (locale === 'en') {
        logo = (
            <div className="mobile-header__logo">
                <Link to="/"><img src="/img/logo/web/apk-logo.png" alt="mobile-logo-en" /></Link>
            </div>
        );
    } else if (locale === 'sr') {
        logo = (
            <div className="mobile-header__logo">
                <Link to="/Home"><img src="/img/logo/web/apk-logo.png" alt="mobile-logo-sr" /></Link>
            </div>
        );
    }

    return (
        <div className="mobile-header">
            <div className="mobile-header__panel">
                <div className="container">
                    <div className="mobile-header__body">
                        <button type="button" className="mobile-header__menu-button" onClick={openMobileMenu}>
                            <Menu18x14Svg />
                        </button>
                        {logo}
                        {/* <Search
                                context="mobile-header"
                                className={searchClasses}
                                inputRef={this.searchInput}
                                onClose={this.handleCloseSearch}
                            />
                            <div className="mobile-header__indicators">
                                <Indicator
                                    className="indicator--mobile indicator--mobile-search d-md-none"
                                    onClick={this.handleOpenSearch}
                                    icon={<Search20Svg />}
                                />
                            </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobileHeader;
